import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_2 = { class: "max-w-[1040px]" }
const _hoisted_3 = {
  key: 0,
  class: "mb-6 text-sm text-red-600"
}

import { onMounted, ref } from 'vue'

import NeueLoading from '@/components/neue/NeueLoading.vue'
import SaveBar from '@/components/SaveBar.vue'
import SecondaryNav from '@/components/SecondaryNav.vue'
import SecondaryTop from '@/components/SecondaryTop.vue'
import { AI_AGENTS } from '@/composables/useAgentSections'
import { useAgentVoiceSettings } from '@/composables/useAgentVoiceSettings'
import { useUnsavedChanges } from '@/composables/useUnsavedChanges'

import AgentVoiceFields from './AgentVoiceFields.vue'


export default {
  __name: 'AgentGeneralSettings',
  setup(__props) {

const loading = ref(true)
const saveError = ref('')
const { form, load, save: persist } = useAgentVoiceSettings()
const { hasUnsavedChanges, reload } = useUnsavedChanges([form])

const discard = () => reload([load()])

const save = () => {
  saveError.value = ''
  return persist()
    .then(() => reload([]))
    .catch(error => {
      saveError.value = error.response?.data?.errors?.[0] || 'Unable to save right now. Please try again.'
    })
}

onMounted(() =>
  reload([load()]).finally(() => {
    loading.value = false
  })
)

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(SecondaryTop, {
        text: "General settings",
        parent: { link: _unref(AI_AGENTS), name: 'AI Agents' }
      }, null, 8, ["parent"]),
      _createVNode(SaveBar, {
        "has-unsaved-changes": _unref(hasUnsavedChanges),
        onOnDiscard: discard,
        onOnSave: save
      }, null, 8, ["has-unsaved-changes"])
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(NeueLoading, { loading: loading.value }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (saveError.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(saveError.value), 1))
                : _createCommentVNode("", true),
              _createVNode(AgentVoiceFields, {
                "brand-voice": _unref(form).brand_voice_summary,
                "onUpdate:brandVoice": _cache[0] || (_cache[0] = $event => ((_unref(form).brand_voice_summary) = $event)),
                emoji: _unref(form).emoji_enabled,
                "onUpdate:emoji": _cache[1] || (_cache[1] = $event => ((_unref(form).emoji_enabled) = $event)),
                "additional-context": _unref(form).additional_context,
                "onUpdate:additionalContext": _cache[2] || (_cache[2] = $event => ((_unref(form).additional_context) = $event)),
                tone: _unref(form).tone,
                "onUpdate:tone": _cache[3] || (_cache[3] = $event => ((_unref(form).tone) = $event)),
                formality: _unref(form).formality_level,
                "onUpdate:formality": _cache[4] || (_cache[4] = $event => ((_unref(form).formality_level) = $event)),
                enthusiasm: _unref(form).enthusiasm_level,
                "onUpdate:enthusiasm": _cache[5] || (_cache[5] = $event => ((_unref(form).enthusiasm_level) = $event))
              }, null, 8, ["brand-voice", "emoji", "additional-context", "tone", "formality", "enthusiasm"])
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }))
}
}

}